import { Component, Input, OnChanges, OnInit, ViewContainerRef, ViewRef } from '@angular/core';

@Component( {
  selector: 'app-control-menu',
  template: '',
  styles: ['']
} )
export class ControlMenuComponent implements OnInit, OnChanges {
  @Input() tmpl;
  tmplRef: ViewRef;

  constructor ( private vcRef: ViewContainerRef ) { }

  ngOnInit () { }

  ngOnChanges () {
    if ( this.tmplRef ) {
      this.tmplRef.destroy();
    }
    this.tmplRef = this.vcRef.createEmbeddedView( this.tmpl );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/control-menu/control-menu.component.ts